import { Clickable, Span } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 4rem;
`;

type InnerWrapperProps = {
  isMobile?: boolean;
  isMobileNavExpanded?: boolean;
};

export const InnerWrapper = styled.div<InnerWrapperProps>`
  border-radius: 0px 0px 40px 40px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  height: 3.5rem;
  padding: 1rem 2rem 1rem 2rem;
  width: ${({ isMobile }) => (isMobile ? 'calc(100vw - 2rem)' : '50rem')};

  ${({ isMobileNavExpanded }) =>
    isMobileNavExpanded &&
    `
      border-radius: 0;
      box-shadow: none;
    `}
`;

type StepWrapperProps = {
  isMobile?: boolean;
};

export const StepWrapper = styled.div<StepWrapperProps>`
  display: flex;
  &:not(:last-child) {
    padding-right: 2rem;
  }

  ${({ isMobile }) =>
    isMobile &&
    `
      padding-bottom: 1rem;
      padding-left: 1rem;
      padding-top: 1rem;
    `}
`;

type StepNumberProps = {
  $isActive: boolean;
  $isBeforeActiveStep: boolean;
};

export const StepNumber = styled.div<StepNumberProps>`
  background-color: ${({ theme }) => theme.colors.grey10};
  border-radius: 50%;
  display: inline-block;
  color: ${({ theme }) => theme.colors.grey50};
  font-size: 0.75rem;
  font-weight: 800;
  height: 28px;
  padding-top: 4px;
  text-align: center;
  width: 28px;

  ${({ $isActive, theme }) =>
    $isActive &&
    `
      background-color: ${theme.colors.black};
      color:${theme.colors.white};
    `}

  ${({ $isBeforeActiveStep, theme }) =>
    $isBeforeActiveStep &&
    `
      background-color: ${theme.colors.black};
      color: ${theme.colors.white};

      >svg {
        fill: ${theme.colors.white};
        position: relative;
        top: 3px;
      }
    `}
`;

export const StepName = styled(Span)`
  color: ${({ theme }) => theme.colors.grey50};
  padding-left: 1rem;

  ${({ $isActive, theme }) =>
    $isActive &&
    `
      color:${theme.colors.black};
    `}

  ${({ $isBeforeActiveStep, theme }) =>
    $isBeforeActiveStep &&
    `
      color:${theme.colors.black};
    `}
`;

export const StyledClickable = styled(Clickable)`
  display: flex;
`;
